import firebase from '../firebase';
import {
  LOGIN_SUCESS,
  LOGIN_ERROR,
  LOGIN_LOADING,
  LOGOUT_LOADING,
  LOGOUT_ERROR,
  LOGOUT_SUCESS,
  LOGIN_CLEAR_ERROR,
} from './types';

export const clearLoginError = () => ({
  type: LOGIN_CLEAR_ERROR,
});

const signInSuccess = payload => ({
  type: LOGIN_SUCESS,
  payload,
});

const signInError = error => ({
  type: LOGIN_ERROR,
  error,
});

export const login = ({ email, password }) => (dispatch) => {
  dispatch({
    type: LOGIN_LOADING,
  });

  firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then(user => dispatch(signInSuccess(user)))
    .catch(err => dispatch(signInError(err)));
};

export const signup = ({ email, password }) => (dispatch) => {
  dispatch({
    type: LOGIN_LOADING,
  });

  firebase
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .then(user => dispatch(signInSuccess(user)))
    .catch(err => dispatch(signInError(err)));
}

export const signInWithToken = token => (dispatch) => {
  dispatch({
    type: LOGIN_LOADING,
  });
  firebase
    .auth()
    .signInWithCustomToken(token)
    .then(user => dispatch(signInSuccess(user)))
    .catch(err => dispatch(signInError(err)));
};

const logoutSuccess = () => ({
  type: LOGOUT_SUCESS,
});

const logoutError = error => ({
  type: LOGOUT_ERROR,
  error,
});

export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT_LOADING,
  });

  firebase
    .auth()
    .signOut()
    .then(() => dispatch(logoutSuccess()))
    .catch(err => logoutError(err));
};



// WEBPACK FOOTER //
// ./src/actions/auth.actions.js